import { ChangeDetectorRef, Component, HostListener, inject, Input, ViewChild  } from '@angular/core';
import { CommonModule} from '@angular/common';
import { BidderCommunityMenuService } from '../../../services/bidder-community/bidder-community-menu/bidder-community-menu.service';
import { faCircleExclamation, faCreditCard, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { Carousel, CarouselModule } from "primeng/carousel";
import { CheckboxModule } from "primeng/checkbox";
import { FormsModule }    from '@angular/forms';
import { DialogModule } from "primeng/dialog";
import { SelectModule } from "primeng/select";
import { InputTextModule } from "primeng/inputtext";
import { CreditCardsInfoFormComponent } from "./credit-cards-info-form/credit-cards-info-form.component";
import { CardModule } from 'primeng/card';
import { ICreditCardDTO } from '../../../models/ICreditCardDTO';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CreditCardItemComponent } from './credit-card-item/credit-card-item.component';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from "primeng/button";
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { environment } from '../../../../environments/environment';
import { CreditCardsService } from '../../../services/bidder-community/credit-cards/credit-cards.service';
import { ToastMessageService } from '../../../services/toast-message/toast-message.service';
import { distinctUntilChanged, Subscription } from 'rxjs';
import { AuthService } from '../../../services/authentication/auth.service';

@Component({
  selector: 'app-credit-cards',
  imports: [
    CarouselModule,
    CommonModule,
    CheckboxModule,
    FormsModule,
    DialogModule,
    SelectModule,
    InputTextModule,
    CreditCardItemComponent,
    CreditCardsInfoFormComponent,
    CardModule,
    ProgressSpinnerModule,
    ButtonModule
],
  templateUrl: './credit-cards.component.html',
  styleUrl: './credit-cards.component.scss'
})
export class CreditCardsComponent {

  @ViewChild('carouselWeb') carouselWeb!: Carousel;
   carouselMobile!: Carousel;

  @ViewChild('carouselMobile')
  set setCarouselMobile(carousel: Carousel) {
    if (carousel) {
      this.carouselMobile = carousel;
    }
  }
  
  private readonly creditCardsService = inject(CreditCardsService);
  private readonly messageService = inject(ToastMessageService); 
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly authService = inject(AuthService);
  isAuthenticated = this.oidcSecurityService.authenticated;

  protected icons = {
    faCreditCard: faCreditCard,
    faShoppingCart: faShoppingCart,
    faCircleExclamation: faCircleExclamation
  }


  isSmallScreen: boolean = true;
  displayDialog: boolean = false;
  isEditing: boolean = false;
  isNewCard: boolean = false;
  isLoadingCardList: boolean = true;
  isCreditCardSelectedOnMobile: boolean = false;
  debugEmptyList: boolean = false;

  cardNumberFormValue: String = '';
  cardHolderFormValue: String = '';
  monthFormValue: String = '';
  yearFormValue: String = '';

  authSubscription!: Subscription;

  
  public cards : ICreditCardDTO[] | null = [];
  
  selectedCard: ICreditCardDTO | null = null;

  @Input() id: number | null = null;
  @ViewChild(CreditCardsInfoFormComponent) CreditCardsInfoFormComponentRef!: CreditCardsInfoFormComponent;

  constructor( 
    private bidderCommunityMenuService: BidderCommunityMenuService, 
    private confirmationService: ConfirmationService,
    private cdr: ChangeDetectorRef){

  }
  
  ngOnInit(){
    setTimeout(() => {
      if (typeof window !== 'undefined') {
        window.onpageshow = function (event) {
          if (event.persisted) {
            window.location.reload();
          }
        };
      }
      this.checkScreenSize();
      this.bidderCommunityMenuService.setPageData(
        {
          id: this.id!,
          pageName: this.calculateDynamicTitle(),
          pageRoute:"credit-cards"
        }
      );

      this.validate();
      
    },100);
    
  }

  validate(){
    if (typeof window !== 'undefined') {
      if (!this.isAuthenticated().isAuthenticated) {
        window.open(environment.mediaUrl, '_self');
        return;
      }
    }
    this.authSubscription = this.authService.isAuthenticated$.pipe(distinctUntilChanged()).subscribe(isAuth => {
      if (!isAuth){
        if (typeof window !== 'undefined') {
          window.open(environment.mediaUrl, '_self');
        }
        return;
      }
    });
  }

  @HostListener('window:resize', ['$event']) onResize(event: Event) {
    this.checkScreenSize();
  }

  refreshPageName(){
    this.bidderCommunityMenuService.setPageData(
      {
        id: this.id!,
        pageName: this.calculateDynamicTitle(),
        pageRoute:"credit-cards"
      }
    );
  }

  private checkScreenSize() {
    if(typeof window !== 'undefined'){
      this.isSmallScreen = window.innerWidth < 1024; 
    }
    this.refreshPageName();
  }

  openAddCreditCardModal(){
    this.isNewCard = true;
    this.turnEditModefunc(!this.isSmallScreen,true);
    this.selectedCard = {
      cardHolderName : '',
      billingAddress: {
        address1: '',
        address2: '',
        city: '',
        countryCode: '',
        region: '',
        zipCode: ''
      },
      creditCardInfo: {
        id: 0,  
        lastDigits: '',
        type: 'credit-card'
      },
      expirationMonth: 1,
      expirationYear: new Date().getFullYear(),
      isDefaultCard: false,
      type: ''
    }
    this.CreditCardsInfoFormComponentRef.form.reset();
  }

  printCardHolder(data : String){
    this.cardHolderFormValue = data;
  }
  printCardNumber(data : String){
    this.cardNumberFormValue = data;
  }
  printMonth(data : String){
    this.monthFormValue = data != null ? data.length < 2 ? '0'+data : data : '';
  }
  printYear(data : String){
    this.yearFormValue = data != null ? data.length == 4 ? data.substring(2,4) : data : '';
  }


  turnEditMode(data: { isWeb:boolean ; value:boolean }){
    if(!data.value && this.CreditCardsInfoFormComponentRef.form.dirty){
      this.confirm(data.isWeb);
    }else{
      this.turnEditModefunc(data.isWeb,data.value)
    }
  }

  turnEditModefunc(isWeb: boolean, value: boolean){
    if(isWeb){
      this.isEditing = value;
      this.isCreditCardSelectedOnMobile = value;
      this.refreshPageName();
    }else{
      this.isEditing = value;
      if(value){
        this.isCreditCardSelectedOnMobile = true;
      }else if(this.isNewCard){
        this.isCreditCardSelectedOnMobile = false;
      }
      this.refreshPageName();
    }
    if(!this.isNewCard){
      this.CreditCardsInfoFormComponentRef.form.get('cardNumber')?.disable();
    }else{
      this.CreditCardsInfoFormComponentRef.form.get('cardNumber')?.enable();
    }
    if(!value){
      this.isNewCard = false;
      this.CreditCardsInfoFormComponentRef.form.markAsPristine();
      this.CreditCardsInfoFormComponentRef.form.markAsUntouched();
      this.CreditCardsInfoFormComponentRef.form.updateValueAndValidity({ onlySelf: false, emitEvent: false });
      if (this.CreditCardsInfoFormComponentRef) {
        this.isLoadingCardList = true;
        this.CreditCardsInfoFormComponentRef.getCreditCardsList(); 
      }
    }
  }

  onDelete(card: ICreditCardDTO){
    this.creditCardsService.deleteCard(card.creditCardInfo.id).subscribe(({
      next: (result) => {
        this.messageService.success(`Card deleted successfully`);
        this.CreditCardsInfoFormComponentRef.selectedCard = null;
        this.CreditCardsInfoFormComponentRef.getCreditCardsList(); 
      },
      error: (err) => {
        if(err.message == 'Credit card is in use, it cannot be deleted'){
          this.confirmationService.confirm({
            header: 'You can’t remove this card yet!',
            message: 'Looks like this card is tied to your active bids. Once your bids are wrapped up, you’ll be able to remove it.',
            icon: 'faCircleInfo',
            rejectLabel: '',
            rejectVisible: false,
            acceptLabel: 'Okay',
            accept: () => {
              
            },
            reject: () => {
                
            }
          });
        }else{
          this.messageService.error(err || 'unknown error');
        }
      }
    }))
  }


  
  calculateDynamicTitle() : string{
    if((this.isCreditCardSelectedOnMobile && !this.isEditing) && this.isSmallScreen){
      return 'Card Info'
    }
    if((this.isCreditCardSelectedOnMobile && this.isEditing) && this.isSmallScreen && this.isNewCard){
      return 'Add New Card'
    }
    if((this.isCreditCardSelectedOnMobile && this.isEditing) && this.isSmallScreen){
      return 'Edit Card'
    }
    return 'Credit Cards'
  }

  onCheckboxChange(card: ICreditCardDTO ) {
    card.isDefaultCard = !card.isDefaultCard;
    this.CreditCardsInfoFormComponentRef.setDefaultCreditCard(card);
  }

  onSelectCardWeb(card: ICreditCardDTO){
    this.selectedCard = card;
    this.CreditCardsInfoFormComponentRef.selectedCard = card;
    this.CreditCardsInfoFormComponentRef.resetSelectedCardValues();
    this.scrollToSelected();
  }

  onSelectCardMobile(card: ICreditCardDTO){
    this.selectedCard = card;
    this.isCreditCardSelectedOnMobile = true;
    this.CreditCardsInfoFormComponentRef.selectedCard = card;
    this.CreditCardsInfoFormComponentRef.resetSelectedCardValues();
    this.refreshPageName();
  }
  
  onBackMobile(){
    this.isCreditCardSelectedOnMobile = false;
    this.isEditing = false;
    this.refreshPageName();
    this.scrollToSelected();
  }

  confirm(isWeb: boolean) {
    this.confirmationService.confirm({
        header: 'Unsaved Changes',
        message: 'Are you sure you want to exit without saving?',
        rejectLabel: 'No, keep editing',
        acceptLabel: 'Yes, exit',
        accept: () => {
          this.turnEditModefunc(isWeb,false)
        },
        reject: () => {
            
        }
    });
  }

  confirmDelete(card: ICreditCardDTO) {
    if(card.isDefaultCard && this.CreditCardsInfoFormComponentRef.creditCardsList!.length > 1){
      var newDefault : ICreditCardDTO | null = null;
      this.CreditCardsInfoFormComponentRef.creditCardsList!.forEach(card_i => {
        if(card_i.creditCardInfo.id != card.creditCardInfo.id && newDefault == null){
          newDefault = card_i;
          return;
        }
      });

      this.confirmationService.confirm({
            header: 'Remove this card?',
            message: 'You’re about to remove your default card. Don’t worry, we’ll make the card ending in ••••'+newDefault!.creditCardInfo.lastDigits+' your new default.You can update this anytime.',
            accept: () => {
                this.onDelete(card);
            },
            reject: () => {

            },
        });
    }else{
      this.confirmationService.confirm({
            header: 'Remove this card?',
            message: 'Do you want to remove the card ending in ••••'+card.creditCardInfo.lastDigits+'?',
            accept: () => {
                this.onDelete(card);
            },
            reject: () => {

            },
        });
    }
  }

  selectedCardChange(card: ICreditCardDTO|null){
    this.selectedCard = card;
    setTimeout(()=> {
      this.scrollToSelected();
    },300)
    
  }

  scrollToSelected(){
    const selectedIndex = this.CreditCardsInfoFormComponentRef.creditCardsList!.findIndex(p => p.creditCardInfo.id === this.selectedCard?.creditCardInfo.id);

    if (selectedIndex !== -1) {
      if(this.isSmallScreen){
        if (this.carouselMobile) {
          setTimeout(()=> {
            const itemsPerPage = this.carouselMobile.numVisible;
            const newPage = selectedIndex / itemsPerPage;
            this.carouselMobile.page = newPage > 0 ? newPage : 0 ;
            this.cdr.detectChanges();
          },300)
        }
      }else{
        if (this.carouselWeb) {
          const itemsPerPage = this.carouselWeb.numVisible;
          const newPage = selectedIndex / itemsPerPage;
          this.carouselWeb.page =  newPage > 0 ? newPage : 0  ;
          this.cdr.detectChanges();
        }
      }
      
    }
  }

  

}
